import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useSearchParams } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Dashboard from './pages/Dashboard';
import CharterStudio from './pages/CharterStudio';
import CompassStudio from './pages/CompassStudio';
import StartupStudio from './pages/StartupStudio';
import TomeMachine from './pages/TomeMachine';
import JoinProject from './pages/JoinProject';
import LandingPage from './pages/LandingPage';
import ShareView from './pages/ShareView';
import './App.css';

// Wrapper component to handle landing page vs dashboard
function AppContent() {
  // Initialize showLanding based on localStorage immediately
  const [showLanding, setShowLanding] = useState(() => {
    const userName = localStorage.getItem('blissabode_user_name');
    return !userName;
  });
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    // Check for SSO callback - if present, show landing to process it
    const bs_user = searchParams.get('bs_user');
    if (bs_user) {
      setShowLanding(true);
    }
  }, [searchParams]);

  const handleEnterApp = () => {
    setShowLanding(false);
  };

  // Routes that should always be accessible regardless of login state
  return (
    <Routes>
      <Route path="/share/:shareCode" element={<ShareView />} />
      <Route path="/startup" element={<StartupStudio />} />
      <Route path="/tome" element={<TomeMachine />} />
      <Route path="/join/:projectId" element={<JoinProject />} />
      <Route path="/welcome" element={<LandingPage onEnter={handleEnterApp} />} />
      <Route path="/charter/:projectId" element={<CharterStudio />} />
      <Route path="/compass/:projectId" element={<CompassStudio />} />
      <Route path="/" element={showLanding ? <LandingPage onEnter={handleEnterApp} /> : <Dashboard />} />
      <Route path="*" element={showLanding ? <LandingPage onEnter={handleEnterApp} /> : <Dashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <AppContent />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
